import React from 'react';
import { translate, Trans } from 'react-i18next';
import moment from 'moment';
import Color from 'color';
import { Feed, Icon,Button, Image } from 'semantic-ui-react';

import Utils from '../../utils/Utils.js';
import LoadInline from '../loading/LoadInline.js';
import {colors, fontSizes, fonts, spacings, layout, shadow, shadowLight} from 'style';
import defaultAvatar from 'img/default-avatar.png';
import ReportActivityModalContainer  from './modal/ReportActivityModalContainer.js';
import PopUpMenuContainer from '../navigation/PopUpMenuContainer.js';
import Render0Block from './Render0Block.js';
import Render1Block from './Render1Block.js';
import Render2Block from './Render2Block.js';
import Render3Block from './Render3Block.js';



const Palette = {
    primary: colors.themeBlue,
    secondary: colors.themeTeal,
    points: colors.pointsYellow,
    body: colors.themeDarkerGrey,
    subtext: colors.themeDarkGrey,
    warning: colors.warningRed
};

const Sizes = {
    caption: '12px',
    subtext: '14px',
    body: '16px',
    header: '18px',
    title: '20px',
    h2: '24px',
    h1: '32px',
    x1: '40px'
}

const Margins = {
    default: '16',
    none: '0',
    micro: '1',
    mini: '2',
    tiny: '4',
    small: '8',
    medium: '16',
    large: '24',
    xlarge: '32',
    xxlarge: '48',
    xxxlarge: '64',
}

const Alignments = {
    left: 'left',
    center: 'center',
    right: 'right'
}

var style = {
    content: {
        height:'100%',
        lineHeight: '1.5',
        color: Color(colors.themeDarkerGrey).alpha(0.75).toString(),
        ...fonts.body,
    },
    body: {
        paddingBottom: spacings.base,
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
        maxWidth: '620px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    item: {
        marginTop: spacings.small,
        marginBottom: spacings.small,
        boxShadow: shadowLight,
        backgroundColor: 'white',
    },
    itemContent: {
        position: 'relative',
        width: '100%',
        display: 'block',
        marginTop: '0px',
        marginBottom: '0px',
        verticalAlign: 'top',
        minHeight: '127px',
    },
    itemHeader: {
        padding: spacings.base,
    },
    avatarArea: {
        position: 'absolute',
        top: '0px',
  
    },
    avatarImage: {
        width: '48px',
        height: '48px',
        display: 'block', 
        position: 'relative',
        top: spacings.base,
        borderRadius: '50%', 
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundColor: Palette.primary,
        border: '2px solid #fff',
        boxShadow : 'rgba(0, 0, 0, 0.25) 2px 2px 3px 0.5px',
    },
    iconProfile: {
        color: '#fff',
        fontSize: '3em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '60px',
        height: '60px',
        marginLeft: '-30px',
        marginTop: '-30px',
        lineHeight: '60px',
        padding: '0 0 0 0',
    },
    heart:{
        position: 'relative',
        bottom: '-4px',
        color : colors.heartRed,
        fontSize: '24px',
        marginRight: '0px',
    },
    ellipsis: {
        color:colors.themeDarkGrey,
        backgroundColor : '#fff',
        opacity: '0.75',
        fontSize: '24px',
    },
    ellipsisButton: {
        position: 'relative',
        backgroundColor: '#fff',
        float:'right',
        width:'20px',
        height:'60px',
        lineHeight: '1',
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    likeButton: {
        color : colors.themeDarkGrey,
        position: 'relative',
        backgroundColor: '#fff',
        width:'150px',
        height:'60px',
        lineHeight: '1',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'left',
        fontSize: fontSizes.bodyL,
    },
    likeButtonLiked: {
        color : colors.heartRed,
        position: 'relative',
        backgroundColor: '#fff',
        width:'150px',
        height:'60px',
        lineHeight: '1',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'left',
        fontSize: fontSizes.bodyL,
    },
    activityImageArea: {
        position: 'relative',
        width : '100%',
    },
    renderBlock: {
        paddingLeft: spacings.micro
    },
    renderBlockRounded: {
        marginLeft: spacings.small,
        marginRight: spacings.small,
        borderRadius: '10px'
    },
  
    user:{
        color: colors.themeTeal,
        fontWeight: 'bold',
        cursor: 'default',
        display: 'inline',
    },
    date: {
        color: Palette.subtext,
    },
    info: {
        verticalAlign: 'top',
        display: 'inline-block',
        paddingLeft: '65px',
        paddingRight: '60px',
        width: '100%',
    },
    infoLine1: {
        display: 'inline',
    },
    title: {
        color: Palette.primary,
        fontWeight: 'bold',
        display: 'inline',
    },
    itemDetail : {
    },
    itemFooter : {
        marginLeft : '30px'
    },
    report : {
        color: colors.warningRed
    },
    pageTitle: {
        textAlign: 'center',
        color: Palette.primary,
        ...fonts.h2,
        paddingTop: spacings.large,
        paddingBottom: '32px',
        paddingLeft: spacings.large,
        paddingRight: spacings.large,
    },
    buttonRow: {
        backgroundColor: '#fff',
        height: '60px',
    },
    caption: {
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
        paddingBottom: spacings.base,
    },
    attributes: {
        padding: spacings.base,
    },
    
    dataStyle: {
        display: 'inline-block',
        padding: '45px 20px'
    },
    fullPhotoAction: {
        position: 'relative',
        top: '-6px', //fix for mystery 'padding'
        backgroundColor: colors.themeGrey,
        color: 'rgba(0, 0, 0, 0.75)',
        padding: spacings.tiny,
        cursor: 'pointer',
    },
    actionTextInset: {
        color: Palette.primary,
        fontSize: fontSizes.h4,
    },
    actionText: {
    },
    actionSubText: {
        color: Palette.subtext,
        fontSize: fontSizes.bodyL,
    },
    
    
    popUpMenuContainer: {
        top : "calc(100% - 8px)",
        right : "-17px",
        width : "auto"
    },
};

const displayableAttributes = {
    "calories": true,
    "description": true,
    "start_time": true,
    "duration": true,
}

const Activities = ({t, 
                    pageTitle,
                    activities,
                    activity, 
                    onScroll, 
                    setScrollContainer, 
                    hasAvatar, 
                    busy,
                    showReportActivity,
                    onLikeActivity,
                    onShowReportActivity,
                    challengeReportReason,
                    onTogglePopUpMenu,
                    onShowPopUpMenu,
                    getData,
                    getMargin,
                    onAction,
                    showPopUpMenu}) => (
    <div className='scrollable' style={style.content} onScroll={onScroll} ref={(el)=>(setScrollContainer(el))}>
        <div style={style.pageTitle}>
            {pageTitle}
        </div>
        <div style={style.body}>
            <div>
            {activities.map((activity)=>(
                <div style={style.item} key={activity.id}>
                    <div style={style.itemContent}>
                        <div style={style.itemHeader}>
                            <div style={style.avatarArea}>
                                <span style={{...style.avatarImage, backgroundImage:'url('+(hasAvatar(activity) ? activity.header.avatar.url : defaultAvatar)+')'}}></span>
                            </div>
                            <div style={style.info}>
                                <Trans i18nKey={activity.header.title.key}><span style={{color:Palette[activity.header.title.args[0].color]}}>{{p1:activity.header.title.args[0].data}}</span> {activity.header.title.data.replace("{fullName}", "")}</Trans>
                                <div style={style.date}>{moment(activity.timestamp).fromNow()}</div>
                            </div>
                        </div>

                        {activity.content.map((content, index) => (
                                <div key={index} style={{...(Utils.deref(content, 'navigation') ? {cursor: 'pointer'} : {})}} onClick={()=>onAction(Utils.deref(content, 'navigation', null))}>
                                    <div style={{display: 'flow-root', 
                                                    color: Palette[content.color], 
                                                    fontSize: Boolean(Sizes[content.size]) ? Sizes[content.size] : content.size + 'px', 
                                                    textAlign: content.align,
                                                    margin: (Boolean(content.render != 1 && content.render != 2) ? '8px' : '8px 0px 8px 0px'),
                                                    padding: getMargin(Margins, content), 
                                                    backgroundColor: (Boolean(content.render && content.render != 2) ? colors.themeNearWhite : content.backgroundColor),
                                                    borderRadius: (Boolean(content.render == 3) ? spacings.base : spacings.none),
                                                    borderLeft: Boolean(content.render == 4) ? '0.5rem solid ' + Palette[content.borderColor] : ''}}>
                                        {Boolean(content.render == 0) &&
                                            <Render0Block t = {t} content={content} onAction={onAction}/>
                                        }
                                        {Boolean(content.render == 1) && 
                                           <Render1Block t = {t} content={content} getData={getData} />
                                        }
                                        {Boolean(content.render == 2) &&
                                            <Render2Block content={content} onAction={onAction} getData={getData} />
                                        }
                                        {Boolean(content.render == 3) &&
                                            <Render3Block content ={content} t = {t} getData = {getData} />
                            
                                        }
                                        {Boolean(content.render == 4) &&
                                                getData(Boolean(content.key) ? t(content.key) : content.data, content.args, content, Palette, Margins, Sizes, Alignments)  
                                        }
                                        {Boolean(!content.render) && 
                                                getData(Boolean(content.key) ? t(content.key) : content.data, content.args, content, Palette, Margins, Sizes, Alignments)
                                        }
                                        
                                    </div>
                            </div>
                            

                        ))}
                        
                    
                        {Boolean(activity.attributes) &&
                            <div style={style.attributes}>
                                {activity.attributes.filter(att => displayableAttributes[att.key]).map(att => (
                                    <div key={att.key}>{t('news_feed_attribute_'+att.key)}: {att.key==='start_time' ? moment(new Date(att.data)).format('MMMM Do YYYY, h:mm:ss a') : att.data}</div> 
                                ))}
                            </div>
                        } 
                        </div>

                       
                    <div style={style.buttonRow}>
                        <Button style={(activity.feedActionReaction=== null) ? style.likeButton : style.likeButtonLiked} onClick={()=>onLikeActivity(activity)}>
                            <Icon name={(activity.feedActionReaction=== null) ? "heart outline" : "heart"} style={style.heart}/> {activity.feedActionReaction !== null ? t('Liked') : 'Like'}
                        </Button>
                        <Button style={style.ellipsisButton} onClick={()=>onTogglePopUpMenu(activity.id)}>
                            <Icon className="icon-ellipsis" style={style.ellipsis}/> 
                            {showPopUpMenu[activity.id] && 
                                <PopUpMenuContainer t={t}
                                                    style = {style.popUpMenuContainer}
                                                    popUpMenuLinks = {[{title:"Report", onClick: () => onShowReportActivity(activity,challengeReportReason,true), style:style.report}]}
                                                    onClose={()=>onShowPopUpMenu(activity.id, false)}/>
                            }
                        </Button>
                    </div>
                </div>
            ))}
            </div>
            <LoadInline centered style={{...(busy ? {} : {visibility: 'hidden'})}} /> 
            {Boolean(showReportActivity) &&
                <ReportActivityModalContainer activity={activity}
                                        challengeReportReason = {challengeReportReason}
                                        onClose={()=>onShowReportActivity(activity,challengeReportReason,false)}
                                        />
            }
        </div>
    </div> 
);

export default translate('newsfeed')(Activities);



// WEBPACK FOOTER //
// ./src/modules/newsfeed/Activities.js